export enum BalanceOperationTab {
  TransFer = 0,
  Encashment = 1
}

export enum BalanceOperationTabAction {
  SendMoneyToOrCashIn = 1,
  GetMoneyFromOrCashOut = 2
}

export enum TransactionTableTabs {
  BalanceMonitoring = 1,
  LimitMonitoring = 2,
  Request = 3,
}

export enum TransactionStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
}

export enum TransactionType {
  Send = 0,
  Receive = 1,
  CashOut = 2,
  CashIn = 3,
}

export enum UpdateBalanceAction {
  Approve = 1,
  Reject = 2,
  Seen = 3
}